export const RouteEnum = {
    PRODUCT_RANGE: "/product-range",
    COLLECTIONS: "/collections",
    FAVOURITES: "/favourites",
    SPARE_PARTS: "/spare-parts",
    ACCOUNT: "/account",
    PRICEBOOK: "/pricebook",
    SEARCH: "/search",
    REFURBISHED: "/refurbished",
    REFURBISHED_CART: "/refurbished/cart",
    REFURBISHED_CHECKOUT: "/refurbished/checkout",
    REFURBISHED_CHECKOUT_THANK_YOU: "/refurbished/checkout/thank-you",
};
